module.exports = __webpack_public_path__ + "images/a11804d.png";